import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { NetworkErrorService } from '../services/network-error.service';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  private readonly REQUEST_TIMEOUT = 300000; // 5 minutes

  constructor(private networkErrorService: NetworkErrorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError((error) => {
        if (error instanceof TimeoutError) {
          this.networkErrorService.showNetworkErrorPopup(req);
        }
        return throwError(() => error);
      })
    );
  }
}

// Register it globally
export const TimeoutInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: TimeoutInterceptor,
  multi: true,
};